import cn from 'classnames'
import {FC, ReactNode} from 'react'

import {IconSize} from '@/theme/icons'
import {theme} from '@/theme/theme'

import {Text, TextFontWeight, TextVariant} from '../content/Text'
import {InfoIcon} from '../icons/InfoIcon'
import {FormTextHelper} from './FormTextHelper'
import {FormTooltip} from './tooltip/FormTooltip'

type FormItemProps = {
  label?: ReactNode
  required?: boolean
  color?: string
  button?: ReactNode
  tooltipText?: string
  helperText?: string | ReactNode
  gap?: string
}

export const FormItem: FC<React.PropsWithChildren<FormItemProps>> = ({
  label,
  required,
  color = theme.palette.text.light,
  button,
  tooltipText,
  helperText,
  gap = theme.spacing[3],
  children,
}) => (
  <>
    <div className="wrapper">
      {label && (
        <div className="label">
          <div className={cn('title', button && 'title-with-button')}>
            <Text
              variant={TextVariant.text14}
              element="span"
              color={color}
              fontWeight={TextFontWeight.medium}
            >
              {label}
              {required && '*'}
            </Text>
            {tooltipText && (
              <span className="tooltip">
                <FormTooltip tooltipText={tooltipText} />
              </span>
            )}
          </div>
          {button}
        </div>
      )}
      <div data-test="FormItem-item" className="item">
        {children}
      </div>
      {helperText && (
        <div className="helper">
          <FormTextHelper
            message={helperText}
            icon={<InfoIcon color={theme.palette.gray[600]} size={IconSize.medium} />}
          />
        </div>
      )}
    </div>

    <style jsx>{`
      .wrapper + .wrapper {
        margin-top: ${gap};
      }
      .label {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-bottom: ${theme.spacing[1.5]};
      }
      .title-with-button {
        margin-right: ${theme.spacing[3]};
      }
      .tooltip::before {
        content: ' ';
        word-spacing: ${theme.spacing[1]};
      }
      .item {
        display: flex;
        flex-direction: column-reverse;
      }
      .helper {
        margin-top: ${theme.spacing[1]};
      }
    `}</style>
  </>
)
